export default function SectionHeading({ eyebrow, title, subtitle, align = "left", light = false }) {
    const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
    const titleColor = light ? "text-white" : "text-[#0A2540]";
    const subColor = light ? "text-white/70" : "text-[#475569]";
    return (
        <div className={`${alignCls} max-w-3xl`}>
            {eyebrow && <div className="overline mb-4">{eyebrow}</div>}
            <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight ${titleColor}`}>
                {title}
            </h2>
            {subtitle && (
                <p className={`mt-5 text-base sm:text-lg leading-relaxed ${subColor}`}>{subtitle}</p>
            )}
        </div>
    );
}
